module.exports = __webpack_public_path__ + "img/ceaa-fast-2026.b38b3dc8.jpg";